module.exports = __webpack_public_path__ + "img/PTT.7b1ab5d4.png";